import { themes, type ThemeName } from "./themes";

export function isThemeName(value: string | null | undefined): value is ThemeName {
  return value === "sc" || value === "poly";
}

/**
 * 在客户端应用主题：写入 CSS 变量并同步 data-theme。
 */
export function applyTheme(themeName: ThemeName) {
  if (typeof document === "undefined") return;

  const theme = themes[themeName] ?? themes.poly;
  const root = document.documentElement;

  root.dataset.theme = theme.name;

  for (const [token, value] of Object.entries(theme.tokens)) {
    root.style.setProperty(`--${token}`, value);
  }
}
